<div class="templateBody">
  <p *ngIf="isAdmin"><b>Procedure Designer: </b></p>
  <p *ngIf="isAdmin==false"><b>Procedure Designer: </b>{{procedureDesignerDisplay}}</p>

  <form *ngIf="submissionForm" [formGroup]="submissionForm" novalidate>

    <!-- **BASE -->
    <div [formGroup]="baseForm">

      <!-- Update procedure designer only if user is a administrator -->
      <div class="form-group" [ngClass]="isValid('selectedPD')">
        <div>
          <p-select *ngIf=isAdmin [options]="procedureDesigners" placeholder="None" filter="true" [style]="{'width':'500px'}"
            [showClear]="true" optionLabel="name_email" formControlName="selectedPD" styleClass="primeng-custom">
          </p-select>
        </div>
      </div>

      <!-- airport -->
      <div class="form-group" [ngClass]="isValid('selectedAirport')">
        <label class="block">Airport<span style="color:red">*</span></label>
        <small class="small-block">Select the airport for this procedure
          change.</small>
        <div>
          <p-select #aptCombo [editable]="true" [options]="airports" optionLabel="label" [style]="{'width':'400px'}"
            placeholder="Search" formControlName="selectedAirport" [(ngModel)]="selectedAirportReset"
            styleClass="primeng-custom" (onChange)="updateAirportList($event,aptCombo)">
          </p-select>
        </div>
        <div *ngIf="hasError('selectedAirport')">
          <p class="err-msg" [innerText]="getErrorMsg('selectedAirport')"></p>
        </div>
      </div>

      <!-- airway -->
      <div class="form-group" *ngIf="useAirway">
        <label class="block">Airway</label>
        <small class="small-block">Select the airway for this procedure
          change.</small>
        <div>
          <p-select #awyCombo [editable]="true" [options]="airways" optionLabel="label" [style]="{'width':'400px'}"
            placeholder="Search" formControlName="selectedAirway" [(ngModel)]="selectedAirwayReset"
            styleClass="primeng-custom" (onChange)="updateAirwayList($event,awyCombo)">
          </p-select>
        </div>
      </div>

      <!-- toggle navaid -->
      <div class="form-group">
        <div class="checkbox reduce-top">
          <label>
            <input type="checkbox" formControlName="useNavaid">Specify NAVAID.
          </label>
        </div>
      </div>

      <div class="form-group" *ngIf="useNavaid.value">
        <label class="block">NAVAID</label>
        <small class="small-block">Select a NAVAID for this procedure change.</small>
        <div>
          <p-select #navaidCombo [editable]="true" [options]="navaids" optionLabel="label" [style]="{'width':'500px'}"
            placeholder="Search" formControlName="selectedNavaid" [(ngModel)]="selectedNavaidReset"
            styleClass="primeng-custom" (onChange)="updateNavaidList($event,navaidCombo)">
          </p-select>
        </div>
      </div>

      <!-- date -->
      <div class="form-group">
        <label class="block">Publication Date</label>
        <small class="small-block">Enter the publication date (e.g. 2018-10-25) of the procedure(s) if known.</small>
        <div>
          <p-datepicker [monthNavigator]="true" [yearNavigator]="true" yearRange="2022:2024" dateFormat="yy-mm-dd"
            [style]="{'width':'350px'}" formControlName="publicationDate">
          </p-datepicker>
        </div>
      </div>

      <!-- contact -->
      <div class="form-group">
        <label class="block">Airport Contact</label>
        <small class="small-block">Select the name of the Airport Contact. If your contact is not on the list, invite a
          new contact using the text box below.</small>
        <div>
          <p-select [options]="airportContacts" placeholder="None" filter="true" [style]="{'width':'500px'}"
            [showClear]="true" optionLabel="name_email" formControlName="selectedContact">
          </p-select>
        </div>
      </div>

      <!-- email -->
      <div class="form-group" [ngClass]="isValid('inviteEmail')" *ngIf="showEmailInvite">
        <label>Invite New Airport Contact Email</label>
        <small class="small-block">Invite a new airport contact via email by entering their email address here.</small>
        <input type="email" class="form-control reduce-width" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$"
          formControlName="inviteEmail">
        <div *ngIf="hasError('inviteEmail')">
          <p class="err-msg" [innerText]="getErrorMsg('inviteEmail')"></p>
        </div>
      </div>
    </div>

    <!-- tabs -->
    <p-tabs value="0" class="primeng-custom">
      <p-tablist>
        <p-tab value="0">IFP Specialist</p-tab>
        <p-tab value="1" *ngIf="showAirportForm">Airport Contact</p-tab>
        <p-tab value="2" *ngIf="showEnvironmentForm">Service Center Environmental Specialist</p-tab>
      </p-tablist>

      <p-tabpanels>
        <!-- **IFP specialist -->
        <p-tabpanel value="0" [formGroup]="ifpForm">

        <!-- request type -->
        <div class="form-group">
          <label>Procedure Request Type</label>
          <small class="small-block font90">Is this request for a new or amended procedure?</small>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="procedureRequestType" value="New" formControlName="procedureRequestType">New
              Procedure Request
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="procedureRequestType" value="Amended"
                formControlName="procedureRequestType">Amended
              Procedure Request
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="procedureRequestType" value="JetRts"
                formControlName="procedureRequestType">Establishment of Jet Routes or Federal Airways
            </label>
          </div>          
        </div>

        <div class="form-group"  *ngIf="showPublic">
          <label>Public or Private</label>
          <small class="small-block font90">Is this procedure public or private?</small>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="isPrivate" value="no" formControlName="isPrivate">Public
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="isPrivate" value="yes"
                formControlName="isPrivate">Private
            </label>
          </div>
        </div>        
        
        <!-- procedure count -->
        <div class="form-group">
          <label>Single Or Multiple Procedures</label>
          <small class="small-block font90">Do these changes pertain to a single procedure or multiple procedures at an
            airport? Group procedure processing is only available for procedural changes that solely involve the
            Specific Actions for Exclusion as listed below.</small>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="isSingle" value='yes' formControlName="isSingle">Single
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="isSingle" value='no' formControlName="isSingle">Multiple
            </label>
          </div>
        </div>

        <!-- procedure name -->
        <div class="form-group" [ngClass]="isValid('procedureName')">
          <label>Procedure Name <span style="color:red">*</span></label>
          <small class="small-block font90">Enter the name of the procedure. Click “Add Additional Procedures” below for submissions with multiple procedures.</small>
          <textarea formControlName="procedureName" class="form-control" rows="1"></textarea>
          <!-- <input type="text" class="form-control" formControlName="procedureName"> -->
          <div *ngIf="hasError('procedureName')">
            <p class="err-msg" [innerText]="getErrorMsg('procedureName')"></p>
          </div>
        </div>

        <!-- procedure description -->
        <div class="form-group" [ngClass]="isValid('procedureDescription')">
          <label>Procedure Description <span style="color:red">*</span></label>
          <small class="small-block font90">Provide details about the new procedure(s), or briefly describe all
            procedural changes for the amended procedure(s). This information will be included in the CATEX
            Declaration, if applicable.</small>
          <textarea formControlName="procedureDescription" class="form-control" rows="4"></textarea>
          <div *ngIf="hasError('procedureDescription')">
            <p class="err-msg" [innerText]="getErrorMsg('procedureDescription')"></p>
          </div>
        </div>

        <button class="btn btn-primary form-btn" data-toggle="tooltip" title="Add additional procedures" (click)="addProcedure()" *ngIf="onlyProcedure">Add Additional Procedures</button>
        <p *ngIf="moreProcedures"><b>{{label}}</b></p>

        <div style="margin-top: 15px; margin-bottom: 15px">
          <form [formGroup]="procedureTable" *ngIf="moreProcedures">
            <table class="table table-border" [ngClass]="{'table-dark': mode}">
              <thead class="text-nowrap">
                <tr>
                  <th>Procedure Name</th>
                  <th style="width: 50vw;">Procedure Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody formArrayName="procedureRows">
                <tr *ngFor="let group of getFormControls.controls; let i = index" [formGroupName]="i">
                  <ng-container *ngIf="group.get('isEditable').value; else readOnlyRow">
                    <td>
                      <mat-form-field>
                        <input matInput type="text" formControlName="procedureName">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field>
                        <textarea matInput formControlName="procedureDescription" rows="3" style="width:100%;"></textarea>
                      </mat-form-field>
                    </td>
                    <td>
                      <button pButton class="btn1" type="button" (click)="deleteRow(i)">Delete Row</button>
                      <button pButton type="button" (click)="doneRow(group)">Edit Complete</button>
                    </td>
                  </ng-container>
                  <ng-template #readOnlyRow>
                    <td>{{ group.get('procedureName').value }}</td>
                    <td>{{ group.get('procedureDescription').value }}</td>
                    <td>
                      <button pButton class="edit" type="button" (click)="editRow(group)">Edit</button>
                    </td>
                  </ng-template>
                </tr>
              </tbody>
            </table>

            <div class="action-container">
              <button pButton class="btn1" type="button" (click)="addRow()">Add row</button>
            </div>
          </form>
        </div>

        <!-- procedure benefit and need -->
        <p-panel header="PROCEDURE BENEFIT AND NEED" [toggleable]="true" styleClass="primeng-custom">
          <b>Please complete the benefit and need, if known, or attach the consensus form below.</b> 

          <!-- procedure benefit -->
          <div class="form-group" [ngClass]="isValid('procedureBenefit')" style="margin-top: 20px">
            <label>Procedure Benefit <span style="color:red">*</span></label>
            <small class="small-block">Describe any operational, economic, and/or environmental benefits
               that will result if the project is implemented (if known).</small>
            <textarea formControlName="procedureBenefit" class="form-control" rows="7"></textarea>
            <div *ngIf="hasError('procedureBenefit')">
              <p class="err-msg" [innerText]="getErrorMsg('procedureBenefit')"></p>
            </div>
          </div>

          <!-- procedure need -->
          <div class="form-group" [ngClass]="isValid('procedureNeed')">
            <label>Procedure Need <span style="color:red">*</span></label>
            <small class="small-block">Indicate if the proposed project is the result of a user or community
               request or regulatory mandate. If neither, describe what is necessitating the action.</small>
            <textarea formControlName="procedureNeed" class="form-control" rows="7"></textarea>
            <div *ngIf="hasError('procedureNeed')">
              <p class="err-msg" [innerText]="getErrorMsg('procedureNeed')"></p>
            </div>
          </div>

          <!-- consensus form -->
          <div class="form-group">
            <label>Attached Consensus Form</label>
            <small class="small-block font90">Attach the Consensus Form which includes the Purpose and Need
              information.</small>
            <small class="small-block font90">File must be less than <b>4 MB</b>. Allowed file types: <b>txt pdf doc
                docx zip csv xls xlsx</b>.</small>
            <p-fileUpload #cmpConsensus [showCancelButton]="false" customUpload="true"  
              (uploadHandler)="uploadFile(cmpConsensus,'consensus')" accept=".txt,.pdf,.doc,.docx,.zip,.csv,.xls,.xlsx"
              multiple="multiple" maxFileSize="4000000" styleClass="primeng-custom" [disabled]="ifpUploadDisabled">
            </p-fileUpload>
            <div *ngIf="hasUploaded('consensus')">
              <label style="margin-top: 10px;">Uploaded</label>
              <ul class="list-unstyled">
                <li *ngFor="let file of consensusFile">
                  <span style="margin-left: 15px;">{{file.originalFileName}}</span>
                  <button class="btn btn-primary btn-xs" style="margin-left:15px; margin-bottom:5px; width:25px;"
                    (click)="confirmDelete(file)" *ngIf="!ifpUploadDisabled">x</button>
                </li>
              </ul>
            </div>
          </div>
        </p-panel>

        <!-- change details -->
        <p-panel [toggleable]="true" styleClass="primeng-custom" *ngIf="isAmended"> 
          <ng-template pTemplate="header">
             <b>CHANGE DETAILS</b> &nbsp; <b><span style="color:red">*</span></b>
        </ng-template>
          <small class="small-block font90">Specific Actions for Categorical Exclusion, in accordance with FAA Order
            1050.1</small>
          <div class="form-group">
            <label style="margin-top: 10px">New or Revised</label>
            <div class="row">
              <div class="col-md-5">
                <div class="checkbox" *ngFor="let opt of newOrRevisedOptions | slice:0:4;  let i = index"
                  [ngClass]="(i==0) && 'reduce-top'" formArrayName="newOrRevised">
                  <label>
                    <input type="checkbox" name="opt" [formControlName]="i">
                    {{opt.label}}
                  </label>
                </div>
              </div>
              <div class="col-md-5">
                <div class="checkbox" *ngFor="let opt of newOrRevisedOptions | slice:4;  let i = index"
                  [ngClass]="(i==0) && 'reduce-top'" formArrayName="newOrRevised">
                  <label>
                    <input type="checkbox" name="opt" [formControlName]="i+4">
                    {{opt.label}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Emergency Actions</label>
            <div class="checkbox reduce-top">
              <label><input type="checkbox" formControlName="emergencyActions">
                Missed approaches and/or Missed approach holding patterns
              </label>
            </div>
          </div>
          <div class="form-group">
            <label style="margin-top: 10px">Publication Actions</label>
            <div class="row">
              <div class="col-md-5">
                <div class="checkbox" *ngFor="let opt of pubActionsOptions | slice:0:3;  let i = index"
                  [ngClass]="(i==0) && 'reduce-top'" formArrayName="pubActions">
                  <label>
                    <input type="checkbox" name="opt" [formControlName]="i">
                    {{opt.label}}
                  </label>
                </div>
              </div>
              <div class="col-md-5">
                <div class="checkbox" *ngFor="let opt of pubActionsOptions | slice:3;  let i = index"
                  [ngClass]="(i==0) && 'reduce-top'" formArrayName="pubActions">
                  <label>
                    <input type="checkbox" name="opt" [formControlName]="i+3">
                    {{opt.label}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Are these the only changes to the procedure?</label>
            <small class="small-block font90">If none of the above changes apply, select No.</small>
            <div class="radio reduce-top">
              <label>
                <input type="radio" name="isFieldOnlyChange" value='yes' formControlName="isFieldOnlyChange">Yes
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" name="isFieldOnlyChange" value='no' formControlName="isFieldOnlyChange">No
              </label>
            </div>
          </div>
        </p-panel>

        <!-- procedure details -->
        <p-panel header="PROCEDURE DETAILS" [toggleable]="true" styleClass="primeng-custom" [hidden]="!isShowDetails">

          <div class="form-group">
            <label>Procedure Type</label>
            <small class="small-block font90">Select the operation type of the procedure.</small>
            <div class="checkbox reduce-top">
              <label>
                <input type="checkbox" formControlName="procedureTypeIsApproach">Approach
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input type="checkbox" formControlName="procedureTypeIsDeparture">Departure
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input type="checkbox" formControlName="procedureTypeIsEnroute">Enroute
              </label>
            </div>
          </div>

          <!-- helicopter -->
          <div class="form-group">
            <label>Helicopter</label>
            <small class="small-block font90">Does the procedure contain only helicopter operations?</small>
            <div class="radio reduce-top">
              <label>
                <input type="radio" name="isOnlyHelicopterOps" value='yes' formControlName="isOnlyHelicopterOps">Yes
                (Helicopter ONLY)
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" name="isOnlyHelicopterOps" value='no' formControlName="isOnlyHelicopterOps">No
                (Involves Fixed Wing Aircraft)
              </label>
            </div>
          </div>

          <!-- emergency helicopter -->
          <div class="form-group" *ngIf="showEmergencyHelo">
            <label>Emergency Helicopter Route</label>
            <small class="small-block font90">Is the helicopter only procedure designated as a emergency helicopter
              procedure?</small>
            <div class="radio reduce-top">
              <label>
                <input type="radio" name="isEmergencyHelo" value='yes' formControlName="isEmergencyHelo">Yes
                (Emergency HELO Request)
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" name="isEmergencyHelo" value='no' formControlName="isEmergencyHelo">No
              </label>
            </div>
          </div>

          <!-- procedure altitude -->
          <div class="form-group" [ngClass]="isValid('procedureAltitude')">
            <label class="block">Procedure Altitude</label>
            <small class="small-block font90">Specify the LOWEST altitude of change, if it is a new procedure, select
              the LOWEST altitude of the procedure.</small>
            <div>
              <p-select [options]="altitudes" optionLabel="label" placeholder="Select a value"
                [style]="{'width':'225px'}" formControlName="procedureAltitude" styleClass="primeng-custom">
              </p-select>
            </div>
            <div *ngIf="hasError('procedureAltitude')">
              <p class="err-msg" [innerText]="getErrorMsg('procedureAltitude')"></p>
            </div>
          </div>

          <!-- procedure graphic -->
          <div class="form-group">
            <label>Attached Procedure Graphic</label>
            <small class="small-block font90">Attach any supporting graphical documentation on procedure.</small>
            <small class="small-block font90">Files must be less than <b>4 MB</b>. Allowed file types: <b>png gif jpg
                jpeg pdf</b>.</small>
            <p-fileUpload #cmpGraphic [showCancelButton]="false" customUpload="true" 
              (uploadHandler)="uploadFile(cmpGraphic,'graphic')" accept=".png,.gif,.jpg,.jpeg,.pdf" multiple="multiple"
              maxFileSize="4000000" styleClass="primeng-custom" [disabled]="ifpUploadDisabled">
            </p-fileUpload>
            <div *ngIf="hasUploaded('graphic')">
              <label style="margin-top: 10px;">Uploaded</label>
              <ul class="list-unstyled">
                <li *ngFor="let file of graphicFile">
                  <span style="margin-left: 15px;">{{file.originalFileName}}</span>
                  <button class="btn btn-primary btn-xs" style="margin-left:15px; margin-bottom:5px; width:25px;"
                    (click)="confirmDelete(file)" *ngIf="!ifpUploadDisabled">x</button>
                </li>
              </ul>
            </div>
          </div>

          <!-- procedure track -->
          <div class="form-group">
            <label>Specify Procedure Track</label>
            <div style="margin-left:15px;">

              <!-- kml file -->
              <p><b>Attach a KML file</b></p>
              <small class="small-block font90">Please provide a kml file representing the new or amended procedure or
                enter the coordinates in the text field below. For amended procedures only the coordinates associated
                with the change are required.</small>
              <small class="small-block font90">File must be less than <b>4 MB</b>. Allowed file types:
                <b>kml kmz</b>.</small>
              <p-fileUpload #cmpKml [showCancelButton]="false" customUpload="true" 
                (uploadHandler)="uploadFile(cmpKml,'kml')" accept=".kml,.kmz" maxFileSize="4000000"
                styleClass="primeng-custom" [disabled]="ifpUploadDisabled || kmlUploadDisabled">
              </p-fileUpload>
              <div *ngIf="hasUploaded('kml')">
                <label style="margin-top: 10px;">Uploaded</label>
                <ul class="list-unstyled">
                  <li *ngFor="let file of kmlFile">
                    <span style="margin-left: 15px;">{{file.originalFileName}}</span>
                    <button class="btn btn-primary btn-xs" style="margin-left:15px; margin-bottom:5px; width:25px;"
                      (click)="confirmDelete(file)" *ngIf="!ifpUploadDisabled">x</button>
                  </li>
                </ul>
              </div>

              <!-- track coordinate -->
              <p style="margin-top:15px;"><b>Track Coordinate Input</b></p>
              <small class="small-block font90"><b>Degrees, Minutes, Seconds:</b> Enter 2 or more procedure track
                coordinates in Degrees, Minutes, Seconds, separated by a dash or a forward slash (e.g.
                360422.01N/1151005.97W ) with each coordinate on a separate line. A fix or waypoint designation can be
                added by adding the fix or waypoint name and a space before the track coordinates. The fix or waypoint
                name can be any combination of letters or numbers (e.g. WYPNT 360422.01N/1151005.97W). Waypoints with
                names containing special characters will not be parsed.</small>
              <small class="small-block font90"><b>Decimal Degrees:</b> Enter 2 or more procedure track coordinates in
                decimal degrees separated by a comma (e.g. 33.950191,-118.401665) with each coordinate on a separate
                line. Enter only number values; no direction letters should be included.</small>
              <textarea formControlName="trackCoordinateInput" class="form-control" rows="3"></textarea>
              <div *ngIf="hasError('trackCoordinateInput')">
                <p class="err-msg" [innerText]="getErrorMsg('trackCoordinateInput')"></p>
              </div>
            </div>
          </div>

          <!-- map -->
          <div class="map-div" style="margin-bottom:15px;" #mapDiv></div>

          <!-- additional documentation -->
          <div class="form-group">
            <label>Attached Additional Documentation</label>
            <small class="small-block font90">Attach any additional documentation that may aid in the pre-screening
              process.</small>
            <small class="small-block font90">File must be less than <b>4 MB</b>. Allowed file types: <b>txt pdf doc
                docx zip csv xls xlsx</b>.</small>
            <p-fileUpload #cmpAdditional [showCancelButton]="false" customUpload="true" 
              (uploadHandler)="uploadFile(cmpAdditional,'additional')"
              accept=".txt,.pdf,.doc,.docx,.zip,.csv,.xls,.xlsx" multiple="multiple" maxFileSize="4000000"
              styleClass="primeng-custom" [disabled]="ifpUploadDisabled"></p-fileUpload>
            <div *ngIf="hasUploaded('additional')">
              <label style="margin-top: 10px;">Uploaded</label>
              <ul class="list-unstyled">
                <li *ngFor="let file of additionalFile">
                  <span style="margin-left: 15px;">{{file.originalFileName}}</span>
                  <button class="btn btn-primary btn-xs" style="margin-left:15px; margin-bottom:5px; width:25px;"
                    (click)="confirmDelete(file)" *ngIf="!ifpUploadDisabled">x</button>
                </li>
              </ul>
            </div>
          </div>
        </p-panel>
        </p-tabpanel>

        <!-- **Airport contact -->
        <p-tabpanel value="1" [formGroup]="airportForm" *ngIf="showAirportForm">

        <!-- annual operations counts -->
        <div class="form-group" [ngClass]="isValid('operationCounts')">
          <label>Annual Operations Counts</label>
          <small class="small-block font90">Enter the annual anticipated operations utilizing the procedure for each
            time period.</small>
          <table class="table" [ngStyle]="{'width':isAptInCal?'680px':'480px'}" formArrayName="operationCounts">
            <colgroup>
              <col width="80">
            </colgroup>
            <tr>
              <th></th>
              <th>Day<br>(7:00AM-9:59PM)</th>
              <th *ngIf="isAptInCal">Evening<br>(7:00PM-9:59PM)</th>
              <th>Night<br>(10:00PM-6:59AM)</th>
            </tr>
            <tr>
              <td><b>Helo</b></td>
              <td><input type="number" class="form-control number-input" min="0" [formControlName]="0"></td>
              <td *ngIf="isAptInCal"><input type="number" class="form-control number-input" min="0"
                  [formControlName]="1">
              </td>
              <td><input type="number" class="form-control number-input" min="0" [formControlName]="2"></td>
            </tr>
            <tr>
              <td><b>Props</b></td>
              <td><input type="number" class="form-control number-input" min="0" [formControlName]="3"></td>
              <td *ngIf="isAptInCal"><input type="number" class="form-control number-input" min="0"
                  [formControlName]="4">
              </td>
              <td><input type="number" class="form-control number-input" min="0" [formControlName]="5"></td>
            </tr>
            <tr>
              <td><b>Jets</b></td>
              <td><input type="number" class="form-control number-input" min="0" [formControlName]="6"></td>
              <td *ngIf="isAptInCal"><input type="number" class="form-control number-input" min="0"
                  [formControlName]="7">
              </td>
              <td><input type="number" class="form-control number-input" min="0" [formControlName]="8"></td>
            </tr>
          </table>
          <div *ngIf="hasError('operationCounts')">
            <p class="err-msg" [innerText]="getErrorMsg('operationCounts')"></p>
          </div>
        </div>

        <!-- noise sensitive areas -->
        <div class="form-group">
          <label>Noise Sensitive Area(s)</label>
          <small class="small-block font90">Select any noise sensitive area(s) inside the boundary identified on the
            procedure map.</small>
          <div class="row">
            <div class="col-md-3">
              <div class="checkbox" *ngFor="let area of noiseAreas | slice:0:7;  let i = index"
                [ngClass]="(i==0) && 'reduce-top'" formArrayName="areas">
                <label>
                  <input type="checkbox" name="area" [formControlName]="i">
                  {{area}}
                </label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="checkbox" *ngFor="let area of noiseAreas | slice:7;  let i = index"
                [ngClass]="(i==0) && 'reduce-top'" formArrayName="areas">
                <label>
                  <input type="checkbox" name="area" [formControlName]="i+7">
                  {{area}}
                </label>
              </div>
            </div>
          </div>

          <div *ngIf="hasError('areas')">
            <p class="err-msg" [innerText]="getErrorMsg('areas')"></p>
          </div>
        </div>

        <!-- airport notes -->
        <div class="form-group">
          <label>Airport Notes</label>
          <small class="small-block font90">Briefly describe any noise sensitive area(s) identified above. Please also
            include any other information that may help the environmental specialist make a decision, such as recent
            events around the airport, or areas of controversy.</small>
          <textarea formControlName="airportNotes" class="form-control" rows="7"></textarea>
        </div>

        <!-- airport files -->
        <div class="form-group">
          <label>Attached File</label>
          <small class="small-block font90">File must be less than <b>4 MB</b>. Allowed file types: <b>txt pdf doc
              docx zip csv xls xlsx</b>.</small>
          <p-fileUpload #cmpAirport [showCancelButton]="false" customUpload="true" 
            (uploadHandler)="uploadFile(cmpAirport,'airport')" accept=".txt,.pdf,.doc,.docx,.zip,.csv,.xls,.xlsx"
            multiple="multiple" maxFileSize="4000000" styleClass="primeng-custom" [disabled]="aptUploadDisabled">
          </p-fileUpload>
          <div *ngIf="hasUploaded('airport')">
            <label style="margin-top: 10px;">Uploaded</label>
            <ul class="list-unstyled">
              <li *ngFor="let file of airportFile">
                <span>{{file.originalFileName}}</span>
                <button class="btn btn-primary btn-xs" style="margin-left:15px; margin-bottom:5px; width:25px;"
                  (click)="confirmDelete(file)" *ngIf="!aptUploadDisabled">x</button>
              </li>
            </ul>
          </div>
        </div>
        </p-tabpanel>

        <!-- **Service center environmental specialist -->
        <p-tabpanel value="2" [formGroup]="enviromentForm" *ngIf="showEnvironmentForm">

        <!-- service center -->
        <div class="form-group">
          <label>Service Center</label>
          <small class="small-block font90">Select a service center for this procedure.</small>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="selectedServiceCenter" value="Eastern" formControlName="selectedServiceCenter"
                (change)="testFunct('E')">Eastern
            </label>
          </div>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="selectedServiceCenter" value="Central" formControlName="selectedServiceCenter"
                (change)="testFunct('C')">Central
            </label>
          </div>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="selectedServiceCenter" value="Western" formControlName="selectedServiceCenter"
                (change)="testFunct('W')">Western
            </label>
          </div>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="selectedServiceCenter" value="AFS" formControlName="selectedServiceCenter"
              (change)="testFunct('A')">Flight Standards Service (AFS)
            </label>
          </div>                   
        </div>

        <!-- environmental specialist -->
        <div class="form-group" [ngClass]="isValid('selectedEnvrsSpecialist')" *ngIf="isEditable">
          <label class="block">Environmental Specialist</label>
          <p-select [options]="envrSpecialists" filter="true" placeholder="Select a value" [style]="{'width':'350px'}"
            optionLabel="name_email" formControlName="selectedEnvrsSpecialist">
          </p-select>
          <div *ngIf="hasError('selectedEnvrsSpecialist')">
            <p class="err-msg" [innerText]="getErrorMsg('selectedEnvrsSpecialist')"></p>
          </div>
        </div>

        <!-- historic properties -->
        <div class="form-group" [ngClass]="isValid('selectedHistoricProp')">
          <label class="block">Historic Properties</label>
          <p-select [options]="historicProperties" placeholder="Select a value" [style]="{'width':'350px'}"
            optionLabel="label" formControlName="selectedHistoricProp">
          </p-select>
          <div *ngIf="hasError('selectedHistoricProp')">
            <p class="err-msg" [innerText]="getErrorMsg('selectedHistoricProp')"></p>
          </div>
        </div>

        <!-- shpo letter date sent -->
        <div class="form-group" *ngIf="isEditable">
          <label class="block">SHPO Letter Date Sent</label>
          <div>
            <p-datepicker [monthNavigator]="true" [yearNavigator]="true" yearRange="2015:2024" dateFormat="yy-mm-dd"
              [style]="{'width':'350px'}" formControlName="shpoDate">
            </p-datepicker>
          </div>
        </div>

        <!-- procedure description for Catex -->
        <div class="form-group" [ngClass]="isValid('procedureDescriptionCatex')" style="margin-top: 20px">
          <label>Procedure Description for CATEX Declaration</label>
          <small class="small-block font90">Provide a description of the procedure to be included in the Categorical
            Exclusion Declaration. Refer to the procedure description in the IFP tab for additional information to be
            included in the CATEX declaration.</small>
          <textarea formControlName="procedureDescriptionCatex" class="form-control" rows="7"></textarea>
          <div *ngIf="hasError('procedureDescriptionCatex')">
            <p class="err-msg" [innerText]="getErrorMsg('procedureDescriptionCatex')"></p>
          </div>
        </div>

        <!-- notes -->
        <div class="form-group" [ngClass]="isValid('envrNotes')" style="margin-top: 20px" *ngIf="isEditable">
          <label>Notes</label>
          <textarea formControlName="envrNotes" class="form-control" rows="7"></textarea>
        </div>

        <!-- envr file -->
        <div class="form-group" *ngIf="isEditable">
          <label>Add a new file</label>
          <small class="small-block font90">File must be less than <b>4 MB</b>. Allowed file types: <b>txt pdf doc
              docx zip csv xls xlsx</b>.</small>
          <p-fileUpload #cmpEnvr [showCancelButton]="false" customUpload="true" 
            (uploadHandler)="uploadFile(cmpEnvr,'envr')" accept=".txt,.pdf,.doc,.docx,.zip,.csv,.xls,.xlsx"
            multiple="multiple" maxFileSize="4000000" styleClass="primeng-custom" [disabled]="envrUploadDisabled">
          </p-fileUpload>
          <div *ngIf="hasUploaded('envr')">
            <label style="margin-top: 10px;">Uploaded</label>
            <ul class="list-unstyled">
              <li *ngFor="let file of envrFile">
                <span>{{file.originalFileName}}</span>
                <button class="btn btn-primary btn-xs" style="margin-left:15px; margin-bottom:5px; width:25px;"
                  (click)="confirmDelete(file)">x</button>
              </li>
            </ul>
          </div>
        </div>

        <!-- filter recommendation -->
        <div class="form-group">
          <label>Filter Recommendation</label>
          <small class="small-block font90">This recommendation is automatically calculated based on the filter tool
            flowchart.</small>
          <input type="text" class="form-control" formControlName="filterRecommendation" readonly>
        </div>

        <!-- catex eligible -->
        <div class="form-group" *ngIf="showCatexEligible">
          <label>CATEX Eligible</label>
          <small class=" small-block font90">Indicate if this submission is eligible for one or more CATEX.</small>
          <div class="radio reduce-top">
            <label>
              <input type="radio" name="catexEligible" value="na" formControlName="catexEligible">N/A
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="catexEligible" value="no" formControlName="catexEligible">No
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="catexEligible" value="yes" formControlName="catexEligible">Yes
            </label>
          </div>
        </div>

        <!-- catex -->
        <div class="form-group" *ngIf="showCatexCategory">
          <label>CATEX</label>
          <small class="small-block font90">Select one or more CATEX codes for this submission.</small>
          <div class="checkbox" *ngFor="let code of catexCodes;  let i = index" [ngClass]="{
              'reduce-top': i === 0,'small-text': code === 'This action is associated with a rulemaking action (CATEX B-2.5.a)'}"
            formArrayName="catex">
            <label>
              <input type="checkbox" name="code" [formControlName]="i">
              {{code}}
            </label>
          </div>
          <div *ngIf="hasError('catex')">
            <p class="err-msg" [innerText]="getErrorMsg('catex')"></p>
          </div>
        </div>
        <div class="form-group" *ngIf="showCatexCategoryAirway">
          <label>CATEX</label>
          <small class="small-block font90">Select one or more CATEX codes for this submission.</small>
          <div class="checkbox" *ngFor="let code of catexCodesAirway;  let i = index" [ngClass]="{
              'reduce-top': i === 0,'small-text': code === 'This action is associated with a rulemaking action (CATEX B-2.5.a)'}"
            formArrayName="catex">
            <label>
              <input type="checkbox" name="code" [formControlName]="i">
              {{code}}
            </label>
          </div>
          <div *ngIf="hasError('catex')">
            <p class="err-msg" [innerText]="getErrorMsg('catex')"></p>
          </div>
        </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <!-- current editor -->
    <div [formGroup]="revisionForm">
      <div class="form-group" style="margin-top: 10px;">
        <label class="block">Current Form Editor</label>
        <small class="small-block">When you are done entering your information, select one of the choices below to
          hand-off the submission to the next user. If you have not completed entering your information and want to
          save
          the form for future editing, leave your user type selected and select the save option at the bottom of the
          form. Ensure the correct selection has been made before saving the form.</small>
        <div class="radio reduce-top">
          <label>
            <input type="radio" name="workflowState" value="IFP" formControlName="workflowState">IFP
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" name="workflowState" value="Airport" formControlName="workflowState">Airport
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" name="workflowState" value="Service Center" formControlName="workflowState">Service
            Center
          </label>
        </div>
        <div class="radio" *ngIf="isServiceCenterAdmin || isPortalAdmin || isAFS">
          <label>
            <input type="radio" name="workflowState" value="Mgr Signature" formControlName="workflowState">Pending Manager Signature
          </label>
        </div> 
        <div class="radio">
          <label>
            <input type="radio" name="workflowState" value="Closed" formControlName="workflowState">Closed
          </label>
        </div>
        <div class="radio" >
          <label>
            <input type="radio" name="workflowState" value="Archive" formControlName="workflowState">Archive
          </label>
        </div>
        <div class="radio" *ngIf="isServiceCenterAdmin || isPortalAdmin || isProcedureDesigner || isIFPAdmin">
          <label>
            <input type="radio" name="workflowState" value="Delete" formControlName="workflowState" ONCLICK="alert('Are you sure you want to delete this procedure? This action cannot be undone once this change is saved.')">Delete
          </label>
        </div>        
      </div>

      <div class="form-group" [ngClass]="isValid('revisionMessage')">
        <label>Revision log message</label>
        <small class="small-block font90">Provide an explanation of the changes you are making. This will help other
          authors understand your motivations.</small>
        <textarea class="form-control" rows="4" formControlName="revisionMessage"></textarea>
        <div *ngIf="hasError('revisionMessage')">
          <p class="err-msg" [innerText]="getErrorMsg('revisionMessage')"></p>
        </div>
      </div>

      <p-table [columns]="cols" [value]="revisionLogs" *ngIf="showLog">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="text-align:center" [ngStyle]="{'width':col.width}" *ngFor="let col of columns"
              [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-log let-columns="columns">
          <tr>
            <td *ngFor="let col of columns; let i = index" [ngClass]="(i==1) && 'grid-align-left'">
              {{col.isDate ? (log[col.field] | date:'EEE, y-MM-dd HH:mm') : log[col.field]}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- submit -->
    <button type="submit" class="btn btn-primary form-btn" [disabled]="!submissionForm.valid" (click)="onSubmit()">
      Save</button>
    <button type="button" class="btn btn-primary form-btn" style="margin-left:10px" (click)="cancelForm()">
      Cancel</button>
    <div *ngIf="hasEntered('selectedAirport')">
      <p class="err-msg" [innerText]="getErrorMsg('selectedAirport')"></p>
    </div>
    <div *ngIf="hasEntered('procedureName')">
      <p class="err-msg" [innerText]="getErrorMsg('procedureName')"></p>
    </div>
    <div *ngIf="hasEntered('procedureDescription')">
      <p class="err-msg" [innerText]="getErrorMsg('procedureDescription')"></p>
    </div>
    <div *ngIf="hasError('trackCoordinateInput')">
      <p class="err-msg" [innerText]="getErrorMsg('trackCoordinateInput')"></p>
    </div>
    <div *ngIf="hasEntered('operationCounts')">
      <p class="err-msg" [innerText]="getErrorMsg('operationCountsDet')"></p>
    </div>
    <div *ngIf="hasEntered('areas')">
      <p class="err-msg" [innerText]="getErrorMsg('noiseAreas')"></p>
    </div>
    <div *ngIf="hasError('inviteEmail')">
      <p class="err-msg" [innerText]="getErrorMsg('inviteEmailDet')"></p>
    </div>
    <div *ngIf="hasEntered('reviewerName')">
      <p class="err-msg" [innerText]="getErrorMsg('reviewerNameDet')"></p>
    </div>
    <div *ngIf="hasEntered('newOrRevised')">
      <p class="err-msg" [innerText]="getErrorMsg('neworRevised')"></p>
    </div> 
    <div *ngIf="hasEntered('procedureBenefit')">
      <p class="err-msg" [innerText]="getErrorMsg('procedureBenefit')"></p>
    </div>       
    <div *ngIf="hasEntered('procedureNeed')">
      <p class="err-msg" [innerText]="getErrorMsg('procedureNeed')"></p>
    </div>     
  </form>

  <!-- <button class="btn btn-primary" (click)="debug()">Debug</button>  -->

  <p-dialog header="Error" [(visible)]="showError" [modal]="true" [closeOnEscape]="false">
    <span>{{errorMessage}}</span>
    <p-footer>
      <button type="button" pButton (click)="showError=false" label="Close"></button>
    </p-footer>
  </p-dialog>

  <p-confirmDialog></p-confirmDialog>
</div>